import devStore from "./configure-store.dev";
import prodStore from "./configure-store.prod";

export default process.env.NODE_ENV === "production" ? prodStore : devStore;
